import React from 'react';
import { Timeline } from 'antd';
import { TimelineProps } from 'antd/lib/timeline';

export type { TimelineProps };

const ProTimeline: React.FC<TimelineProps> = (props) => {
  const { children, ...resProps } = props;

  return <Timeline {...resProps}>{children}</Timeline>;
};

export default ProTimeline;
